import { render } from "./IssueCardFoldable.vue?vue&type=template&id=83089d8c"
import script from "./IssueCardFoldable.vue?vue&type=script&lang=js"
export * from "./IssueCardFoldable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__